import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { UsageDashboard } from '@/components/features/admin/usage/UsageDashboard';
import { TLAI_FEATURE_FLAGS } from '@/constants';
import { devToolsQueryOptions } from '@/hooks/use-dev-tool-toggle';
import { useFeatureFlag } from '@/hooks/use-feature-flag';
import { ErrorBoundary, ErrorFallback } from '@/modus/ErrorBoundary';
import { userHasRoles } from '@/utils/roles';

const usageSearchSchema = z.object({
  tab: z.enum(['tokens', 'costs']).optional().catch(undefined),
});

export const Route = createFileRoute('/_protected/usage')({
  validateSearch: usageSearchSchema,
  beforeLoad: async ({ context }) => {
    if (!userHasRoles(context.user, ['llm-usage-dashboard-admin', 'llm-usage-dashboard-viewer'])) {
      throw redirect({ to: '/' });
    }

    const devTools = await context.queryClient.ensureQueryData(devToolsQueryOptions());
    if (devTools.SHOW_BUSINESS_DASHBOARD) {
      throw redirect({ to: '/business-dashboard' });
    }
  },
  component: UsageRoute,
});

function UsageRoute() {
  // The new navigation's sidebar owns the Tokens/Costs switch for this route
  // (the admin usage route keeps the in-page switcher — it has no nav entry).
  const newNavigationEnabled = useFeatureFlag(TLAI_FEATURE_FLAGS.NEW_NAVIGATION, false);

  return (
    <ErrorBoundary fallback={(error) => <ErrorFallback error={error} />}>
      <UsageDashboard hideTabSwitcher={newNavigationEnabled} />
    </ErrorBoundary>
  );
}
